"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const schema = {
    type: "object",
    properties: {
        pastAppointment: (0, common_1.makeAppointmentSchema)({
            disableFuture: true,
            isRequired: true,
        }),
        physicianName: {
            type: "string",
            title: "Physician Name",
        },
        contactPersonAtDoctorOffice: {
            type: "string",
            title: "Contact Person at Doctor's Office",
        },
        recertFrequency: {
            type: "string",
            title: "Recert Frequency",
        },
        aideRequired: {
            type: "boolean",
            default: false,
            oneOf: [
                { const: true, title: "Yes" },
                { const: false, title: "No" },
            ],
        },
        frequencyForAide: {
            type: "string",
            title: "Frequency For Aide",
        },
    },
    required: ["recertFrequency"],
};
exports.default = schema;
